(function (angular) {
    'use strict';

    angular
        .module('app.purchase')
        .controller('app.purchase.stateVerificationModalController', [
            '$uibModalInstance',
            stateVerificationModalController
        ]);

    function stateVerificationModalController($uibModalInstance) {
        var vm = this;
        vm.siteContent = siteContent;
        vm.done = done;
        vm.dismiss = dismiss;

        //Close the modal
        function done() {
            $uibModalInstance.close(true);
        }

        function dismiss() {
            $uibModalInstance.close(false);
        }
    }
})(angular);
